export default (() => 

    class extends wealthify.componentBases.Field {
        constructor (config = {}) {
            super(config);

            this.styleSelectors.add(this.constructor.userDefinedBaseStyleSelector);

            this.onConnectedCallback = () => {
                this.deprecatedAttachAdditionalProps(this.freeFormProps);
            };
        }

        //static

        static userDefinedBaseStyleSelector = 'c-field-user-defined-base';

        static get validFormats() {
            return [
                ...Object.values(this.baseFormatEnums),
                ...Object.values(this.formatEnums ? this.formatEnums : [])
            ];
        }

        static baseFormatEnums = Object.freeze({Default: 'default'});

        static formatAttributes = Object.freeze([
            'type',
            'inputmode'
        ]);

        static formatIgnoredProperties = Object.freeze([
            'variantFormat',
            'variants'
        ])

        static defaultFormat = 'default';

        //instance

        #isBaseFormatActive = false;
        #isVariantFormatActive (variantPattern) {
            return variantPattern.toString() === this.#internalVariantFormatPattern;
        }
        set #variantFormatPattern (variantPattern) {
            this.#internalVariantFormatPattern = variantPattern ? variantPattern.toString() : variantPattern;
        }
        #internalVariantFormatPattern = null;

        freeFormProps = Object.freeze([
            {
                class: new wealthify.Prop('format', {
                    default: this.constructor.defaultFormat,
                    type: wealthify.propTypes.ArrayItem(this.constructor.validFormats)
                }),
                callback: () => {
                    if (this.format === 'default') {
                        return;
                    }

                    const formatObject = this.constructor.formatDictionary[this.format];
                    
                    if (!formatObject) {
                        return wealthify.error.throwError(this.tagName, `${this.format} format rules must be added to formatDictionary.`);
                    }
                    
                    const hasFormatVariants = this.constructor.formatDictionary[this.format].variants !== undefined;
                    
                    this.#addRelevantFormatBasedOnValue();

                    if (hasFormatVariants) {
                        // If variants are present, swap rules depending on whether changed value matches the variant's variantPattern property
                        this.addEventListener(this.events.ValueChange.name, this.#addRelevantFormatBasedOnValue.bind(this));
                    }
                }
            }
        ]);

        //private methods
        #addRelevantFormatBasedOnValue() {
            let formatObject = this.constructor.formatDictionary[this.format];
            const matchingVariantFormats = formatObject.variants?.filter(this.#matchesFormatPattern.bind(this));
            const hasMatchingVariantFormat = matchingVariantFormats?.length > 0;

            if (hasMatchingVariantFormat) {
                // Check if variant format is already applied first
                if (this.#isVariantFormatActive(matchingVariantFormats[0].variantPattern)) {
                    return;
                }

                // Include overall format pattern to be added to input
                const variantFormatObject = {
                    ...matchingVariantFormats[0],
                    [wealthify.FieldValidation.validationPropEnums.Pattern]: formatObject[wealthify.FieldValidation.validationPropEnums.Pattern]
                };

                this.#addValidationPropsAndAttributes(variantFormatObject);

                this.#variantFormatPattern = matchingVariantFormats[0].variantPattern;
                this.#isBaseFormatActive = false;
            } else {
                // Check if base format is already applied first
                if (this.#isBaseFormatActive) {
                    return;
                }

                this.#addValidationPropsAndAttributes(formatObject);
                this.#variantFormatPattern = null;
                this.#isBaseFormatActive = true;
            }
        }

        #matchesFormatPattern(formatObject) {
            const formatRegex = new RegExp(formatObject.variantPattern);

            return formatRegex.test(this.value);
        }

        #addValidationPropsAndAttributes(formatObject) {
            for (const key in formatObject) {
                const value = formatObject[key];

                if (this.constructor.formatIgnoredProperties.includes(key)) continue;

                if (this.constructor.formatAttributes.includes(key)) {
                    // Configure properties contained in formatAttribute getter as DOM attributes on input instead of JS property on component
                    this.dom.fieldinput.setAttribute(key, value);
                } else {
                    this[key] = value;
                }
            }
        }

    }
);